import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-12 xl:col-6" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_PrimeVueMessage = _resolveComponent("PrimeVueMessage")!
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_PrimeVueDataTable = _resolveComponent("PrimeVueDataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      class: "mb-3",
      title: _ctx.$t('endpoints_efficiency'),
      "show-refresh-button": _ctx.endpointsEfficiencyFetched,
      "refresh-button-loading": _ctx.endpointsEfficiencyLoading,
      "refresh-button-handler": _ctx.fetchEndpointsEfficiency
    }, null, 8, ["title", "show-refresh-button", "refresh-button-loading", "refresh-button-handler"]),
    (_ctx.endpointsEfficiencyLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          }),
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          }),
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          })
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_PrimeVueMessage, {
                severity: "info",
                closable: false
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("div", { class: "ml-3 mb-2" }, "По задумке данная страница должна помочь с пересмотром параметра Max QPS эндпоинтов", -1),
                  _createElementVNode("div", { class: "ml-3" }, "Данные за последние 5 дней", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_PrimeVueDataTable, {
              value: _ctx.endpointsEfficiency.data
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PrimeVueColumn, {
                  header: "Endpoint ID",
                  field: "endpoint_id",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("a", {
                      href: `/endpoints/${data.endpoint_id}`,
                      target: "_blank"
                    }, _toDisplayString(data.endpoint_compiled_name), 9, _hoisted_4)
                  ]),
                  _: 1
                }),
                _createVNode(_component_PrimeVueColumn, {
                  header: "Max QPS",
                  field: "endpoint_max_qps",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    (data.endpoint_max_qps > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(data.endpoint_max_qps) + " QPS", 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("Unlimited")
                        ], 64))
                  ]),
                  _: 1
                }),
                _createVNode(_component_PrimeVueColumn, {
                  header: "Requests",
                  field: "requests",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(_ctx.$n(data.requests)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_PrimeVueColumn, {
                  header: "Requests %",
                  field: "requests_percent",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(data.requests_percent) + "%", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_PrimeVueColumn, {
                  header: "Feeds $",
                  field: "feeds_payout",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(_ctx.$n(data.feeds_payout, 'payout')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_PrimeVueColumn, {
                  header: "Feeds $ %",
                  field: "feeds_payout_percent",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(data.feeds_payout_percent) + "%", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ], 64))
  ], 64))
}